// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Iwd9","amount":"Amount_amount__1gA9N","tip":"Amount_tip__1CQDx","tipHeader":"Amount_tipHeader__5BSyI","tipsWrap":"Amount_tipsWrap__mJu7H"};